module.exports = __webpack_public_path__ + "img/first_cloud.9db1b5e7.png";